export class SchemaRegistryConfig {
    'url';
    'auth';
    'subjectNamingStrategy';
    'evolutionMode';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "auth",
            "baseName": "auth",
            "type": "SchemaRegistryAuthConfig",
            "format": ""
        },
        {
            "name": "subjectNamingStrategy",
            "baseName": "subjectNamingStrategy",
            "type": "SubjectNamingStrategy",
            "format": ""
        },
        {
            "name": "evolutionMode",
            "baseName": "evolutionMode",
            "type": "SchemaEvolutionMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryConfig.attributeTypeMap;
    }
    constructor() {
    }
}
